import { createSelector } from '@reduxjs/toolkit';
import {
  REVIEWS,
  REVIEWS_PATH_SUFFIX,
} from '../../routes/Hotel/constants/reviews';

import {
  getFromImmutableStateCompatible,
  getImmutableCompatible,
} from '../../utils/immutableUtils';
import { getHotelLink } from '../../routes/Hotel/store/selectors/hotel';
import type { ReviewStore } from './types';

const _getReviewsState = (state) => getImmutableCompatible(state, 'reviews');
export const getReviewsState =
  getFromImmutableStateCompatible<ReviewStore>(_getReviewsState);
export const getReviewsFetching = createSelector(
  getReviewsState,
  (reviews) => reviews.fetching,
);
export const getReviewsVisible = createSelector(
  getReviewsState,
  (reviews) => reviews.visibleCount,
);
export const getReviewsLTRaw = createSelector(
  getReviewsState,
  (reviews) => reviews.data,
);
export const getReviewsLT = createSelector(getReviewsLTRaw, (items) =>
  items
    ? items.map(({ average_rating, ...item }) =>
        // умножаем на 2 рейтинг и округляем, чтобы была 10-бальная шкала
        ({ ...item, average_rating: 2 * Math.round(average_rating) }),
      )
    : [],
);
export const getReviewsLTVisible = createSelector(
  [getReviewsLT, getReviewsVisible],
  (items, visible) => items.slice(0, visible),
);
export const getReviewsLTShowMoreVisible = createSelector(
  [getReviewsLT, getReviewsVisible],
  (items, visible) => items.length > visible,
);

export const getLastReview = createSelector(
  getReviewsLT,
  (items) => items.length > 0 && items[0],
);

export const isLastReview = createSelector([getLastReview], (lastReview) =>
  Boolean(lastReview),
);

export const getReviewsCount = createSelector(
  getReviewsLTRaw,
  (reviews) => reviews.length,
);

export const getReviewsTabs = createSelector(
  [getReviewsCount],
  (ltReviewsCount) => [
    ...(ltReviewsCount
      ? [
          {
            label: REVIEWS.LT.LABEL,
            value: REVIEWS.LT.SLUG,
          },
        ]
      : []),
  ],
);

/**
 * Возвращает ссылку на отельные отзывы
 * @param {object} state reducer
 * @returns hotel public_url(stirng) + '/reviews'
 */
export const getHotelReviewsLink = (state) =>
  `${getHotelLink(state)}${REVIEWS_PATH_SUFFIX}`;
